module.exports = __webpack_public_path__ + "img/Halle_Leer 080.12850acc.jpg";